import { FileTextIcon } from 'lucide-react';

import { ContractType } from '@paid-ui/enums/contract';
import { BrushIcon } from '@paid-ui/icons/brush';
import { DeliveryTruckIcon } from '@paid-ui/icons/delivery-truck';
import { FunderIcon } from '@paid-ui/icons/funder';
import { HelmetIcon } from '@paid-ui/icons/helmet';
import { ArchitectIcon } from '@paid-ui/icons/sketch';

export const contractTypeIcon = {
  [ContractType.HEAD_CONTRACT]: HelmetIcon,
  [ContractType.SUBCONTRACT]: BrushIcon,
  [ContractType.SUPPLY_CONTRACT]: DeliveryTruckIcon,
  [ContractType.SERVICE_CONTRACT]: ArchitectIcon,
  [ContractType.FUNDING_CONTRACT]: FunderIcon,
  [ContractType.DEED]: FileTextIcon,
};

export const contractTypeTextMap = {
  [ContractType.HEAD_CONTRACT]: 'Building contract',
  [ContractType.SUBCONTRACT]: 'Subcontract',
  [ContractType.SUPPLY_CONTRACT]: 'Supply contract',
  [ContractType.SERVICE_CONTRACT]: 'Service contract',
  [ContractType.FUNDING_CONTRACT]: 'Funding contract',
  [ContractType.DEED]: 'Property Deed',
};

export const contractTypeOrder = {
  [ContractType.FUNDING_CONTRACT]: 1,
  [ContractType.HEAD_CONTRACT]: 2,
  [ContractType.SUBCONTRACT]: 3,
  [ContractType.SUPPLY_CONTRACT]: 4,
  [ContractType.SERVICE_CONTRACT]: 5,
  [ContractType.DEED]: 6,
};
